import React, { useEffect, useState } from "react";
import LocalizeListItem from "./components/LocalizeListItem";
import CreateLocalize from "./modal/CreateLocalize";
import PaginationComponent from "../../components/PaginationComponent";
import "./subdomain.css";
import useLocalizeList from "../../utils/CustomHooks/useLocalizeList";
import useLanguageList from "../../utils/CustomHooks/useLanguageList";
import withRoleBased from "../../utils/Functions/withRoleBased";
import { sortArray } from "../../utils/Functions/filter";

function Localize({ access = {} }) {
  const [isOpen, setIsOpen] = useState(false);
  const [count, setCount] = useState(0);
  const { localizeList, loading, getLocalizeList } = useLocalizeList("");
  const { languageList, getLanguageList } = useLanguageList("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(localizeList.length / pageSize);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);
  useEffect(() => {
    let req = {};
    if (search) req.key = search;
    setCurrentPage(0);
    getLocalizeList(req);
  }, [count]);
  useEffect(() => {
    getLanguageList();
  }, []);
  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };
  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row m-0 w-100">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Localized Data </h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-md-end">
            {access.canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Create
              </button>
            )}
          </div>
          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-borderless ">
                <thead>
                  <tr>
                    <td className="col-sm-2">Key</td>
                    <td className={access.canEdit ? "col-sm-4" : "col-sm-5"}>
                      Value
                    </td>
                    <td className="col-sm-2">SubDomain </td>
                    <td className="col-sm-2">Language </td>
                    <td className="col-sm-1">Status</td>
                    {access.canEdit && <td className="col-sm-1">Action</td>}
                  </tr>
                </thead>
                <tbody>
                  {!loading && localizeList && localizeList.length > 0 ? (
                    sortArray(localizeList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <LocalizeListItem
                          item={x}
                          key={i}
                          index={i}
                          languageList={languageList}
                          refresh={() => setCount((x) => x + 1)}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {localizeList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
        <CreateLocalize
          isOpen={isOpen}
          setOpen={() => setIsOpen(false)}
          refresh={() => setCount((x) => x + 1)}
          languageList={languageList}
        />
      </div>
    </main>
  );
}
export default withRoleBased(Localize, "localized");
